const list = [
  {
    text: 'Spending Analysis by Geography',
    id: 'spending-analysis-by-geography',
    downloadLink: 'https://us-east-1.online.tableau.com/api/3.3/sites/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/pdf',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDSpendingTrendsbyGeorgraphy?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'DoD Contract Trends',
    id: 'dod-contract-trends',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractSpendingTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
//   {
//     text: 'Military Installations',
//     id: 'military-installations',
//     html: `<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
//     embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
//   },
  {
    text: 'Prime-Sub Spending Flow',
    id: 'prime-sub-spending-flow',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_AgencySpendingFlow/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'DoD Agency Spending Flow',
    id: 'dod-agency-spending-flow',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_AgencySpendingFlow/DoDSub-AgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'Future Needs of the DoD',
    id: 'future-needs-of-the-dod',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'DoD Contract View',
    id: 'dod-contract-view',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'DoD Contractor View',
    id: 'dod-contractor-view',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'GDX Directory vs. Georgia DoD Contract Winners',
    id: 'gdx-directory-vs-georgia-dod-contract-winners',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  },
  {
    text: 'Georgia Contractor Analysis',
    id: 'georgia-contractor-analysis',
    embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
  }
]

export default list



// WEBPACK FOOTER //
// ./src/analysisList.js